import type { Me } from '@bixo/ui'
import { useSuspenseQuery } from '@tanstack/react-query'
import { meQuery } from './api'

/** True when the user holds a permission. The owner holds "*". */
export function can(me: Me | null | undefined, permission: string): boolean {
  if (!me) return false
  return me.is_owner || me.permissions.includes('*') || me.permissions.includes(permission)
}

/** True when the user holds any permission inside a module, e.g. "users". */
export function canAny(me: Me | null | undefined, module: string): boolean {
  if (!me) return false
  return can(me, '*') || me.permissions.some((p) => p.startsWith(`${module}.`))
}

/**
 * The signed-in user inside the authenticated layout. The layout's guard has
 * already ensured the query, so this never suspends in practice.
 */
export function useMe(): Me {
  const { data } = useSuspenseQuery(meQuery)
  if (!data) throw new Error('useMe() called outside the authenticated layout')
  return data
}

export function useCan(): (permission: string) => boolean {
  const me = useMe()
  return (permission: string) => can(me, permission)
}
